import { EmailDialog } from './Dialogs/EmailDialog';

export default class DialogStore {
  emailDialogStore: EmailDialog;

  constructor() {
    this.emailDialogStore = new EmailDialog();
  }
}
